<template>
  <div class="basic_level_page" :style="{ textAlign: $store.state.isMirroring ? 'right' : 'left' }">
    <Tabbar :title="fromSidebar ? $t('basicLevel.identityVerification') : $t('basicLevel.withdrawTitle')" />
    <div v-if="fromSidebar" class="verify_tabs">
      <div class="verify_tab active">{{ $t('account.basicTab') }}</div>
      <div class="verify_tab" @click="goAdvanced">{{ $t('account.advancedTab') }}</div>
    </div>
    <div v-else class="withdraw_stepper">
      <div class="stepper_line"></div>
      <div class="stepper_item">
        <img class="stepper_icon" src="@/assets/basicLevel/step_done.svg" alt="" />
        <div class="stepper_label active">{{ $t('basicLevel.identityVerification') }}</div>
      </div>
      <div class="stepper_item">
        <div class="stepper_pending">
          <img class="stepper_icon" src="@/assets/basicLevel/step_pending.svg" alt="" />
          <span>2</span>
        </div>
        <div class="stepper_label">{{ $t('basicLevel.withdrawalAccountStep') }}</div>
      </div>
    </div>
    <div class="page_body">
      <!-- 填写基础认证表单 -->
      <div v-if="userLevel === 0 || reWrite || pendingAfterBasic" class="form_list">
        <div class="fill_hint">{{ $t('basicLevel.fillInfoHint') }}</div>
        <Tip :content="$t('basicLevel.basicLevelNote')" />
        <!-- firstName -->
        <CommonFormItem
          v-if="userLevel === 0 || firstName || reWrite"
          class="form_item"
          :label="$t('common.firstName')"
          :note="$t('basicLevel.nameMatchNote')"
          required
        >
          <CommonInput
            v-model="firstName"
            theme="white"
            :placeholder="$t('basicLevel.nameFieldPlaceholder')"
            :onInput="($event) => validateInput($event, 1)"
          >
            <img v-if="firstName" class="field_check" src="@/assets/icon_check_select_green.png" alt="" />
          </CommonInput>
        </CommonFormItem>
        <!-- middleName -->
        <CommonFormItem
          v-if="userLevel === 0 || middleName || reWrite"
          class="form_item"
          :label="$t('common.middleName')"
        >
          <CommonInput
            v-model="middleName"
            theme="white"
            :placeholder="$t('basicLevel.nameFieldPlaceholder')"
            :onInput="($event) => validateInput($event, 2)"
          >
            <img v-if="middleName" class="field_check" src="@/assets/icon_check_select_green.png" alt="" />
          </CommonInput>
        </CommonFormItem>
        <!-- lastName -->
        <CommonFormItem
          v-if="userLevel === 0 || lastName || reWrite"
          class="form_item"
          :label="$t('common.lastName')"
          :required="$store.state.userInfo.countryNo !== 91"
        >
          <CommonInput
            v-model="lastName"
            theme="white"
            :placeholder="$t('basicLevel.nameFieldPlaceholder')"
            :onInput="($event) => validateInput($event, 3)"
          >
            <img v-if="lastName" class="field_check" src="@/assets/icon_check_select_green.png" alt="" />
          </CommonInput>
        </CommonFormItem>
        <!-- gender -->
        <CommonFormItem v-if="!reWrite" class="form_item gender_item" :label="$t('common.gender')" required>
          <div class="radio_group">
            <div :class="gender === 1 && 'selected'" class="gender_radio_btn" @click="gender = 1">
              <img v-show="gender === 1" class="selected_icon" src="@/assets/icon_check_select_green.png" alt="" />
              <img v-show="gender !== 1" class="selected_icon" src="@/assets/icon_check_normal_green.png" alt="" />
              {{ $t('common.female') }}
            </div>
            <div :class="gender === 0 && 'selected'" class="gender_radio_btn" @click="gender = 0">
              <img v-show="gender === 0" class="selected_icon" src="@/assets/icon_check_select_green.png" alt="" />
              <img v-show="gender !== 0" class="selected_icon" src="@/assets/icon_check_normal_green.png" alt="" />
              {{ $t('common.male') }}
            </div>
          </div>
        </CommonFormItem>
        <!-- birthday -->
        <CommonFormItem v-if="!reWrite" class="form_item" :label="$t('common.birthday')" required>
          <div class="field_with_check">
            <SelectDate
              v-model="birthday"
              :placeholder="$t('basicLevel.birthdayPlaceholder')"
              :defaultDate="before18Date"
              :defaultMaxDate="before18Date"
            />
            <img v-if="birthday" class="field_check overlay" src="@/assets/icon_check_select_green.png" alt="" />
          </div>
        </CommonFormItem>
        <!-- email -->
        <CommonFormItem
          v-if="!reWrite"
          class="form_item"
          :label="$t('common.email')"
          :required="!$store.state.userInfo.email"
          :note="emailExistError ? $t('basicLevel.emailRegisteredNote') : ''"
        >
          <div class="email_area" :class="emailAreaFocus && 'focus'">
            <div class="email_input_box">
              <input
                class="email_input_area email"
                :class="[$store.state.isMirroring && 'mirror']"
                v-model="email"
                type="text"
                :placeholder="$t('common.email')"
                autocomplete="off"
                :disabled="!!$store.state.userInfo.email"
                @input="emailExistError = false"
                @focus="emailFocus = true"
                @blur="
                  () => {
                    emailFocus = false
                    checkEmail()
                  }
                "
              />
              <img
                v-if="!!$store.state.userInfo.email"
                class="email_input_icon"
                src="@/assets/icon_check_select_green.png"
                alt=""
              />
              <div
                v-else
                class="send_span"
                :class="(msgValidating || !email) && 'disabled'"
                @click="getEmailCode"
              >
                {{ !msgValidating ? (firstSendMsg ? $t('common.send') : $t('common.resend')) : count + 's' }}
              </div>
            </div>
            <!-- Email Code -->
            <div v-if="!$store.state.userInfo.email" class="email_input_box">
              <input
                ref="emailCodeRef"
                class="email_input_area"
                :class="[$store.state.isMirroring && 'mirror']"
                v-model="emailCode"
                type="text"
                :max-length="VALID_CODE_LENGTH"
                :placeholder="$t('redesign.verifyCodePlaceholder')"
                autocomplete="off"
                @focus="emailCodeFocus = true"
                @blur="emailCodeFocus = false"
              />
            </div>
          </div>
        </CommonFormItem>
        <!-- address -->
        <CommonFormItem v-if="!reWrite" class="form_item" :label="$t('common.address')" required>
          <CommonInput v-model="address" theme="white" :placeholder="$t('basicLevel.addressPlaceholder')">
            <img v-if="address" class="field_check" src="@/assets/icon_check_select_green.png" alt="" />
          </CommonInput>
        </CommonFormItem>
      </div>
      <!-- 基础认证填写完成后的展示页 -->
      <div v-else class="form_list">
        <div class="basic_info_item">
          <div class="basic_info_label">{{ $t('common.firstName') }}</div>
          <div class="basic_info_content">{{ firstName }}</div>
        </div>
        <div class="basic_info_item">
          <div class="basic_info_label">{{ $t('common.middleName') }}</div>
          <div class="basic_info_content">{{ middleName }}</div>
        </div>
        <div class="basic_info_item">
          <div class="basic_info_label">{{ $t('common.lastName') }}</div>
          <div class="basic_info_content">{{ lastName }}</div>
        </div>
        <div class="basic_info_item">
          <div class="basic_info_label">{{ $t('common.gender') }}</div>
          <div class="basic_info_content">{{ gender === 0 ? $t('common.male') : $t('common.female') }}</div>
        </div>
        <div class="basic_info_item">
          <div class="basic_info_label">{{ $t('common.birthday') }}</div>
          <div class="basic_info_content">{{ birthday }}</div>
        </div>
        <div class="basic_info_item">
          <div class="basic_info_label">{{ $t('common.address') }}</div>
          <div class="basic_info_content">{{ address }}</div>
        </div>
      </div>
      <div v-if="userLevel === 0 || reWrite || pendingAfterBasic" class="bottom_btn_box">
        <CommonBtn
          class="confirm_btn"
          :disabled="!canSubmit"
          :text="$t('common.confirm')"
          :onClick="saveBasicInfo"
        ></CommonBtn>
      </div>
    </div>
    <van-popup
      v-model="showConfirmInfo"
      class="confirm_info_popup"
      :close-on-click-overlay="false"
      @closed="stopConfirmCountdown"
    >
      <div class="confirm_info_dialog">
        <div class="confirm_info_title">{{ $t('basicLevel.confirmInfoTitle') }}</div>
        <div class="confirm_info_warning">{{ $t('basicLevel.confirmInfoWarning') }}</div>
        <div class="confirm_info_list">
          <div class="confirm_info_item">
            <span class="confirm_info_label">{{ $t('common.firstName') }}</span>
            <span class="confirm_info_value">{{ firstName }}</span>
          </div>
          <div class="confirm_info_item">
            <span class="confirm_info_label">{{ $t('common.middleName') }}</span>
            <span class="confirm_info_value">{{ middleName || '-' }}</span>
          </div>
          <div class="confirm_info_item">
            <span class="confirm_info_label">{{ $t('common.lastName') }}</span>
            <span class="confirm_info_value">{{ lastName || '-' }}</span>
          </div>
          <div class="confirm_info_item">
            <span class="confirm_info_label">{{ $t('common.gender') }}</span>
            <span class="confirm_info_value">{{ gender === 0 ? $t('common.male') : $t('common.female') }}</span>
          </div>
          <div class="confirm_info_item">
            <span class="confirm_info_label">{{ $t('common.birthday') }}</span>
            <span class="confirm_info_value">{{ formatBirthday }}</span>
          </div>
          <div class="confirm_info_item address_item">
            <span class="confirm_info_label">{{ $t('common.address') }}</span>
            <span class="confirm_info_value">{{ address }}</span>
          </div>
        </div>
        <div class="confirm_info_actions">
          <button
            class="confirm_info_action edit_action"
            type="button"
            :disabled="confirmSubmitting"
            @click="closeConfirmInfo"
          >
            {{ $t('common.edit') }}
          </button>
          <button
            class="confirm_info_action save_action"
            :class="(confirmCountdown > 0 || confirmSubmitting) && 'disabled'"
            type="button"
            :disabled="confirmCountdown > 0 || confirmSubmitting"
            @click="confirmBasicInfo"
          >
            {{
              confirmCountdown > 0
                ? $t('basicLevel.saveCountdown', [confirmCountdown])
                : $t('basicLevel.saveInfo')
            }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar'
import { Toast } from 'vant'
import SelectDate from '@/components/SelectDate'
import moment from 'moment'
import CommonFormItem from '@/components/CommonFormItem.vue'
import CommonInput from '@/components/CommonInput.vue'
import CommonBtn from '@/components/CommonBtn.vue'
import Tip from '@/components/LinkAccount/Tip.vue'
import { VALID_CODE_LENGTH } from '@/utils/constants'
import { postReportLog } from '../utils/log'

export default {
  name: 'BasicLevel',
  components: {
    Tabbar,
    SelectDate,
    CommonFormItem,
    CommonInput,
    CommonBtn,
    Tip
  },
  data() {
    return {
      VALID_CODE_LENGTH,
      reWrite: this.$route.query.reWrite,
      firstName: this.$route.query.reWrite ? '' : this.$store.state.userInfo.firstName,
      middleName: this.$route.query.reWrite ? '' : this.$store.state.userInfo.middleName,
      lastName: this.$route.query.reWrite ? '' : this.$store.state.userInfo.lastName || '',
      birthday: this.$store.state.userInfo.birthday,
      gender: this.$store.state.userInfo.gender,
      address: this.$store.state.userInfo.address,
      email: this.$store.state.userInfo.email || '',
      emailError: true,
      emailExistError: false,
      before18Date: moment().subtract(18, 'years').format('YYYY-MM-DD'),
      count: 59,
      firstSendMsg: true,
      msgValidating: false,
      emailStatus: false,
      emailCode: undefined,
      emailFocus: false,
      emailCodeFocus: false,
      showConfirmInfo: false,
      confirmCountdown: 8,
      confirmTimer: null,
      confirmSubmitting: false,
      pendingBasicParams: null,
      pendingToNext: false,
      pendingAfterBasic: false,
      fillStarted: false,
      basicStartTs: 0
    }
  },
  watch: {
    firstName: 'markBasicStart',
    middleName: 'markBasicStart',
    lastName: 'markBasicStart',
    birthday: 'markBasicStart',
    gender: 'markBasicStart',
    address: 'markBasicStart',
    email: 'markBasicStart',
    emailCode: 'markBasicStart'
  },
  mounted() {
    // 曝光埋点
    postReportLog({
      log_id: '440',
      extra: {
        page: 'basic_level'
      }
    })
  },
  beforeDestroy() {
    this.stopConfirmCountdown()
  },
  computed: {
    userLevel() {
      return this.$store.state.userInfo.level
    },
    fromSidebar() {
      return this.$route.query.from === 'sidebar'
    },
    formatBirthday() {
      if (this.birthday) {
        return moment(this.birthday).format('DD-MM-YYYY')
      }
      return undefined
    },
    emailAreaFocus() {
      return this.emailFocus || this.emailCodeFocus
    },
    canSubmit() {
      const filled = (value) => !!(value && String(value).trim())
      const lastNameOk = this.$store.state.userInfo.countryNo === 91 || filled(this.lastName)
      if (this.reWrite) {
        return filled(this.firstName) && lastNameOk
      }
      const genderOk = this.gender === 0 || !!this.gender
      const emailOk = this.$store.state.userInfo.email
        ? true
        : filled(this.email) && filled(this.emailCode)
      return (
        filled(this.firstName) &&
        lastNameOk &&
        genderOk &&
        filled(this.birthday) &&
        filled(this.address) &&
        emailOk
      )
    }
  },
  methods: {
    markBasicStart() {
      if (this.fillStarted) return
      this.fillStarted = true
      this.basicStartTs = Date.now()
      postReportLog({
        log_id: '440',
        extra: {
          page: 'basic_form',
          action: 'start',
          start_ts: this.basicStartTs
        }
      })
    },
    reportBasicSubmit(result, failReason, errorCode) {
      const extra = {
        page: 'basic_form',
        action: 'submit',
        result,
        fail_reason: failReason || '',
        error_code: errorCode || '',
        start_ts: this.basicStartTs || '',
        duration_ms: this.basicStartTs ? Date.now() - this.basicStartTs : ''
      }
      postReportLog({
        log_id: '440',
        extra
      })
    },
    goAdvanced() {
      this.$router.replace({ name: 'FullyVerified', query: { ...this.$route.query } })
    },
    validateInput(event, type) {
      // 禁止输入符号空格
      const inputValue = event.target.value
      const regex = /^[a-zA-Z]+$/
      this.$nextTick(() => {
        if (!regex.test(inputValue)) {
          switch (type) {
            case 1:
              this.firstName = inputValue.replace(/[^a-zA-Z]/g, '')
              break
            case 2:
              this.middleName = inputValue.replace(/[^a-zA-Z]/g, '')
              break
            case 3:
              this.lastName = inputValue.replace(/[^a-zA-Z]/g, '')
              break
          }
        }
      })
    },
    checkEmail() {
      var regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      this.emailError = !regEmail.test(this.email.toLowerCase())
      if (this.emailError) {
        Toast({
          message: this.$t('loginAndRegister.emailFormatToast')
        })
      }
      return !this.emailError
    },
    // 检查生日是否符合要求
    checkBirthday() {
      console.log(this.birthday, moment(this.birthday), moment())
      if (moment(this.birthday) >= moment()) {
        Toast({
          message: this.$t('basicLevel.birthdayFormatToast')
        })
        return false
      }
      return true
    },
    // 检查必填项
    checkRequired() {
      if (
        !this.firstName ||
        (!this.gender && this.gender !== 0) ||
        !this.birthday ||
        !this.address ||
        (!this.$store.state.userInfo.email && !this.email)
      ) {
        Toast({ message: this.$t('basicLevel.fieldEmptyToast') })
        return false
      } else if (!this.$store.state.userInfo.email && this.email && !this.emailCode) {
        Toast({ message: this.$t('basicLevel.noEmailCodeToast') })
        return false
      }
      return true
    },
    // 检查邮箱验证码是否正确
    async checkEmailCode() {
      const params = {
        email: this.email.toLowerCase(),
        validCode: this.emailCode
      }
      const result = await this.$http.post(
        window.serverPath + '/api/auth/checkEmailCode/CHANGE_BINDING_ACCOUNT',
        params
      )
      if (result.data.code === '200') {
        return true
      } else {
        Toast({
          message: this.$t('basicLevel.verificationCodeError')
        })
        return false
      }
    },
    // 获取邮箱验证码，校验邮箱是否已存在
    getEmailCode() {
      if (this.msgValidating || !this.email) {
        return
      }
      this.checkEmail()
      const $this = this
      const mail = this.email.toLowerCase()
      // 判断邮箱是否符合格式要求
      if (!this.emailError) {
        let url = window.serverPath + '/api/auth/getNewEmailCode/CHANGE_BINDING_ACCOUNT'
        let params = {
          email: mail
        }
        this.$http
          .post(url, params)
          .then((res) => {
            if (res.data.code === '200') {
              $this.msgValidating = true
              $this.firstSendMsg = false
              $this.emailStatus = true
              const interval = window.setInterval(() => {
                $this.count -= 1
                if ($this.count <= 0) {
                  clearInterval(interval)
                  $this.msgValidating = false
                  $this.count = 59
                }
              }, 1000)
              this.$nextTick(() => {
                this.$refs.emailCodeRef.focus()
              })
              // 邮箱账号是否已存在
            } else if (res.data.code === '60001') {
              $this.emailExistError = true
              $this.msgValidating = false
              $this.count = 59
            } else {
              Toast({
                message: res.data.message
              })
              $this.msgValidating = false
              $this.count = 59
            }
          })
          .catch((_err) => {
            $this.msgValidating = false
            $this.count = 59
          })
      } else {
        Toast({
          message: this.$t('loginAndRegister.emailFormatToast')
        })
        $this.msgValidating = false
        $this.count = 59
      }
    },
    saveBasicInfo(toNext = false) {
      if (this.userLevel >= 1 && !this.reWrite && toNext) {
        this.goAfterBasicVerified()
        return
      }
      if (!this.canSubmit) return
      if (!this.checkRequired()) {
        const noEmailCode = !this.$store.state.userInfo.email && this.email && !this.emailCode
        this.reportBasicSubmit('fail', noEmailCode ? 'email_code_empty' : 'empty')
        return
      }
      if (!this.checkBirthday()) {
        this.reportBasicSubmit('fail', 'birthday')
        return
      }
      if (this.email && this.emailCode && !this.checkEmail()) {
        this.reportBasicSubmit('fail', 'email_format')
        return
      }
      // 判断是否是重新编辑修改
      const params = this.reWrite
        ? {
            firstName: this.firstName,
            middleName: this.middleName,
            lastName: this.lastName || ''
          }
        : this.$store.state.userInfo.email
          ? {
              firstName: this.firstName,
              middleName: this.middleName,
              lastName: this.lastName || '',
              birthday: this.birthday,
              gender: this.gender,
              address: this.address
            }
          : {
              firstName: this.firstName,
              middleName: this.middleName,
              lastName: this.lastName || '',
              birthday: this.birthday,
              gender: this.gender,
              address: this.address,
              email: this.email.toLowerCase()
            }
      if (!this.$store.state.userInfo.email && (!this.email || !this.emailCode)) {
        this.reportBasicSubmit('fail', 'email_code_empty')
        Toast({
          message: this.$t('basicLevel.verificationCodeEmpty')
        })
        return
      }
      this.pendingBasicParams = params
      this.pendingToNext = toNext
      this.openConfirmInfo()
    },
    openConfirmInfo() {
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur()
      }
      this.stopConfirmCountdown()
      this.confirmCountdown = 8
      this.showConfirmInfo = true
      this.confirmTimer = window.setInterval(() => {
        if (this.confirmCountdown <= 1) {
          this.confirmCountdown = 0
          this.stopConfirmCountdown()
          return
        }
        this.confirmCountdown -= 1
      }, 1000)
    },
    stopConfirmCountdown() {
      if (this.confirmTimer) {
        window.clearInterval(this.confirmTimer)
        this.confirmTimer = null
      }
    },
    closeConfirmInfo() {
      if (this.confirmSubmitting) return
      this.showConfirmInfo = false
      this.stopConfirmCountdown()
    },
    async confirmBasicInfo() {
      if (this.confirmCountdown > 0 || this.confirmSubmitting || !this.pendingBasicParams) return
      if (!this.$store.state.userInfo.email) {
        const passVerify = await this.checkEmailCode()
        if (!passVerify) {
          this.reportBasicSubmit('fail', 'email_code')
          this.closeConfirmInfo()
          return
        }
      }
      this.confirmSubmitting = true
      this.submitBasicInfo(this.pendingBasicParams)
    },
    submitBasicInfo(params) {
      const url = window.serverPath + (this.reWrite ? '/api/user/baseUserInfo' : '/api/user/editInfo/BASIC_LEVEL')
      this.$http
        .post(url, params)
        .then((res) => {
          if (res.data.code === '200') {
            this.reportBasicSubmit('success')
            this.showConfirmInfo = false
            this.pendingBasicParams = null
            this.$store.commit('setUserInfo', res.data.data)
            Toast.success({
              message: this.$t('basicLevel.successToast')
            })
            if (this.reWrite) {
              this.reWrite = false
              this.confirmSubmitting = false
            } else {
              this.pendingAfterBasic = true
              this.goAfterBasicVerified()
            }
          } else if (res.data.code === '60011') {
            this.reportBasicSubmit('fail', 'api', res.data.code)
            this.confirmSubmitting = false
            Toast(res.data.message)
          } else {
            this.reportBasicSubmit('fail', 'api', res.data.code)
            this.confirmSubmitting = false
            Toast({
              message: this.$t('basicLevel.failToast')
            })
          }
        })
        .catch(() => {
          this.reportBasicSubmit('fail', 'network', 'network')
          this.confirmSubmitting = false
          Toast({
            message: this.$t('basicLevel.failToast')
          })
        })
    },
    goAfterBasicVerified() {
      this.$http
        .get(window.serverPath + '/api/account/withdrawMethods')
        .then((res) => {
          const methods = res.data && res.data.code === '200' && Array.isArray(res.data.data) ? res.data.data : []
          if (methods.length > 0) {
            this.$router.replace({ name: 'Withdrawal' })
            return
          }
          this.$router.replace({
            name: 'MyLinkedAccount',
            query: { from: 'BasicLevel' }
          })
        })
        .catch(() => {
          this.$router.replace({
            name: 'MyLinkedAccount',
            query: { from: 'BasicLevel' }
          })
        })
    }
  }
}
</script>

<style scoped>
.basic_level_page {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-y: auto;
  scrollbar-width: none;
}

.basic_level_page::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.verify_tabs {
  display: flex;
  width: 100%;
  padding: 0 0.16rem;
  box-sizing: border-box;
  border-bottom: 0.01rem solid #efefef;
}

.verify_tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.08rem 0;
  color: #828282;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  border-bottom: 0.02rem solid transparent;
  margin-bottom: -0.01rem;
  box-sizing: border-box;
}

.verify_tab.active {
  color: #3fbb70;
  border-bottom-color: #3fbb70;
}

.withdraw_stepper {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding: 0.16rem 0;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 0.04rem 0.02rem rgba(224, 224, 224, 0.25);
}

.stepper_line {
  position: absolute;
  top: calc(0.16rem + 0.115rem);
  left: 25%;
  width: 50%;
  z-index: 0;
  border-top: 0.01rem dashed #dadada;
  pointer-events: none;
}

.stepper_item {
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.09rem;
  min-width: 0;
}

.stepper_icon {
  width: 0.23rem;
  height: 0.23rem;
  display: block;
}

.stepper_pending {
  position: relative;
  width: 0.23rem;
  height: 0.23rem;
}

.stepper_pending span {
  position: absolute;
  left: 0;
  right: 0;
  top: 0.025rem;
  color: #fff;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-weight: 600;
  line-height: 0.18rem;
  text-align: center;
}

.stepper_label {
  width: 100%;
  padding: 0 0.12rem;
  box-sizing: border-box;
  color: #dadada;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-weight: 500;
  line-height: 0.18rem;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stepper_label.active {
  color: #1ba47a;
}

.page_body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.16rem;
  padding: 0.16rem 0.16rem 0.24rem;
  box-sizing: border-box;
}

.fill_hint {
  width: 100%;
  margin-bottom: 0.12rem;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-weight: 400;
  line-height: 0.2rem;
}

.form_list {
  width: 100%;
}

.form_item {
  margin-bottom: 0.18rem;
}

.form_item.gender_item {
  margin-bottom: 0.16rem;
}

.form_item:last-child {
  margin-bottom: 0;
}

.field_check {
  width: 0.14rem;
  height: 0.14rem;
  flex-shrink: 0;
  margin-inline-start: 0.08rem;
}

.field_with_check {
  position: relative;
}

.field_check.overlay {
  position: absolute;
  top: 50%;
  inset-inline-end: 0.16rem;
  margin-inline-start: 0;
  transform: translateY(-50%);
  pointer-events: none;
}

.radio_group {
  width: 100%;
  display: flex;
  align-items: center;
}

.gender_radio_btn {
  width: 100%;
  height: 0.48rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.08rem;
  border: 0.01rem solid #d6d6d6;
  color: #aaa;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
}

.gender_radio_btn.selected {
  border: 0.01rem solid #3fbb70;
  color: #41c575;
}

.gender_radio_btn:first-child {
  margin-inline-end: 0.16rem;
}

.selected_icon {
  width: 0.14rem;
  height: 0.14rem;
  margin-inline-end: 0.04rem;
}

.email_area {
  width: 100%;
  border-radius: 0.08rem;
  border: 0.01rem solid #d6d6d6;
}

.email_area.focus {
  border: 0.01rem solid #3fbb70;
}

.email_input_box {
  width: 100%;
  padding: 0.1rem 0.16rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 0.48rem;
}

.email_input_box:first-child {
  border-bottom: 0.005rem solid #d6d6d6;
}

.email_input_area {
  color: #2f2f2f;
  font-size: 0.14rem;
  line-height: 0.14rem;
  text-align: left;
  height: 0.48rem;
  background: transparent;
  width: 100%;
  caret-color: #3fbb70;
  font-weight: 600;
}

.email_input_area.email {
  direction: ltr;
}

.email_input_area.mirror {
  text-align: right;
}

.email_input_area::placeholder {
  color: #828282;
  font-weight: 400;
}

.email_input_area::placeholder {
  color: #828282;
  font-weight: 400;
}

.email_input_area.mirror {
  text-align: right;
}

.email_input_icon {
  width: 0.14rem;
  height: 0.14rem;
}

.send_span {
  color: #3fbb70;
  font-size: 0.14rem;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  white-space: nowrap;
}

.send_span.disabled {
  color: #828282;
}

.basic_info_item {
  width: 100%;
  padding: 0.2rem 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.basic_info_label {
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  flex-shrink: 0;
  margin-inline-end: 0.2rem;
}

.basic_info_content {
  text-align: right;
  color: #828282;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
}

.basic_info_content.mirror {
  text-align: left;
}

.bottom_btn_box {
  width: 100%;
  box-sizing: border-box;
  padding: 0;
}

.confirm_btn {
  width: 100% !important;
  font-size: 0.16rem !important;
  background: linear-gradient(90deg, #43d77d 0%, #3fbb70 100%), rgba(0, 0, 0, 0.9) !important;
}

.confirm_btn.disabled {
  background: #c6c6c6 !important;
}

.confirm_info_popup {
  width: calc(100% - 0.48rem);
  max-width: 4.8rem;
  border-radius: 0.24rem;
  overflow: hidden;
}

.confirm_info_dialog {
  width: 100%;
  background: #fff;
  font-family: 'PingFang SC';
}

.confirm_info_title {
  padding: 0.16rem 0.24rem;
  border-bottom: 0.005rem solid #d9d9d9;
  color: #2f2f2f;
  font-size: 0.2rem;
  font-weight: 600;
  line-height: 0.26rem;
  text-align: center;
}

.confirm_info_warning {
  padding: 0.12rem 0.16rem 0;
  color: #ff4c62;
  font-size: 0.12rem;
  font-weight: 400;
  line-height: 0.19rem;
  text-align: start;
}

.confirm_info_list {
  display: flex;
  flex-direction: column;
  gap: 0.16rem;
  max-height: 70vh;
  padding: 0.12rem 0.24rem 0.16rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  color: #1e1e1e;
  font-size: 0.14rem;
  font-weight: 400;
  line-height: 0.2rem;
}

.confirm_info_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 0.2rem;
  gap: 0.16rem;
}

.confirm_info_label {
  color: #807e7e;
  flex-shrink: 0;
}

.confirm_info_value {
  min-width: 0;
  overflow-wrap: anywhere;
  text-align: end;
}

.address_item {
  align-items: flex-start;
}

.address_item .confirm_info_value {
  width: 1.57rem;
}

.confirm_info_actions {
  display: flex;
  flex-shrink: 0;
  width: 100%;
}

.confirm_info_action {
  width: 50%;
  padding: 0.2rem 0;
  border-top: 0.005rem solid #efefef;
  background: #fff;
  font-family: 'PingFang SC';
  font-size: 0.18rem;
  font-weight: 500;
  line-height: 0.22rem;
  text-align: center;
}

.edit_action {
  border-inline-end: 0.005rem solid #efefef;
  color: #4d4d4d;
}

.save_action {
  color: #3fbc71;
}

.save_action:disabled,
.save_action.disabled {
  color: #c6c6c6;
}
</style>

<style>
.basic_level_page .content_item_tip_box {
  margin: 0 0 0.12rem;
}
</style>



// WEBPACK FOOTER //
// src/views/BasicLevel.vue